import React from 'react'

const Donate = () => {
  return (
    <div className='donateQR'>
        <h1 style={{color:"#018d36",fontWeight:"bolder"}}>Donate Now</h1>
        <p style={{color:"darkblue",fontWeight:"bold"}}>Click Button or use QR code below for donation</p>

        <div className="donate-button">
            <a href="https://justgiving.com/kpals" target="_blank" rel="noreferrer" className="btn btn-primary btn-lg" role="button" aria-pressed="true" ><p style={{color:"white", fontWeight:"bold"}}>Donate Now</p></a>
        </div>

        <div className='donateQR'>
            <img src='../img/donate/donate-QR.jpeg' alt='Donate QR' className='donateImage' />
        </div>
           
    </div>
  )
}

export default Donate
